import React, { useEffect, useState } from 'react';
import api from '../api/client';

interface Seller {
  id: number;
  name: string;
  phone: string;
  telegram_id: number | null;
  role_name: string | null;
  status: 'pending' | 'approved' | 'rejected';
  shop_name: string | null;
  is_active: boolean;
  web_username: string | null;
}

const STATUS_CLS: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-700',
  approved: 'bg-success-100 text-success-700',
  rejected: 'bg-red-100 text-red-700',
};

export const Sellers: React.FC = () => {
  const [sellers, setSellers] = useState<Seller[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  const load = async (search = '') => {
    setLoading(true);
    try {
      const res = await api.get('/sellers/', { params: search ? { search } : {} });
      setSellers(res.data.results ?? res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Sotuvchilar</h1>

      <form
        onSubmit={(e) => { e.preventDefault(); load(q); }}
        className="mb-4 flex gap-2 max-w-md"
      >
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Ism yoki telefon bo'yicha qidirish"
          className="input"
        />
        <button className="btn btn-primary">Qidirish</button>
      </form>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Yuklanmoqda...</div>
      ) : (
        <div className="card overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-4 py-3">Ism</th>
                <th className="px-4 py-3">Telefon</th>
                <th className="px-4 py-3">Login</th>
                <th className="px-4 py-3">Rol</th>
                <th className="px-4 py-3">Do'kon</th>
                <th className="px-4 py-3">Holat</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {sellers.map((s) => (
                <tr key={s.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900">{s.name}</td>
                  <td className="px-4 py-3 text-gray-600">{s.phone}</td>
                  <td className="px-4 py-3 text-gray-600">{s.web_username || '—'}</td>
                  <td className="px-4 py-3 text-gray-600">{s.role_name || '—'}</td>
                  <td className="px-4 py-3 text-gray-600">{s.shop_name || '—'}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_CLS[s.status] || ''}`}>
                      {s.status}
                    </span>
                  </td>
                </tr>
              ))}
              {sellers.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-gray-500">Sotuvchi topilmadi</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
